// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import PlaceDeleteModuleCss from "./PlaceDelete.module.css";

let classes = PlaceDeleteModuleCss;

function get(state, field) {
  return state.name;
}

function set(_state, field, value) {
  return {
    name: value
  };
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function PlaceDelete(props) {
  let onConfirm = props.onConfirm;
  let form = Form.use({
    name: ""
  }, Validators$1.schema([
    Validators$1.required("Name"),
    Validators$1.equals(props.placeName, "Jméno místa se neshoduje", "Name")
  ]), param => {
    onConfirm();
  }, undefined, undefined, "OnDemand", undefined);
  return <DialogForm.make
    className={classes.root}
    formId={"place_delete"}
    heading={"Odstranění místa"}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <Form.Provider.make
      value={form}
    >
      <p>
        {`Pokud si přejete smazat místo, napište jeho název a potvrďte. `}
      </p>
      <p
        className={Styles.messageBar.variantDanger}
        role={"alert"}
      >
        <strong>
          {`Smazání místa je nevratná operace!`}
        </strong>
        {` Tímto ztratíte veškeré údaje o místu a nepůjdou vrátit zpět`}
      </p>
      <form
        id={"place_delete"}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={`reset ` + Styles.fieldset.grid}
        >
          <Form.Field.make
            field={"Name"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"name"}
              inputSlot={<input
                type={"text"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={"Název"}
            />}
          />
        </fieldset>
      </form>
    </Form.Provider.make>
  </DialogForm.make>;
}

let make = PlaceDelete;

export {
  classes,
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* classes Not a pure module */
